"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/whySection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type WhySectionChooseSixsItem = {
    key: Key | null | undefined;
    /** Detected variants: "choose-item-six" | "choose-item-six mb-0" */
    className: string;
    /** Detected variants: "01" | "02" | "03" | "04" */
    span0Text: ReactNode;
    /** Detected variants: "Experienced Veterinarians" | "24/7 Emergency Support" | "Modern Facilities" | "Compassionate Care" */
    h30Text: ReactNode;
    /** Detected variants: "Our team of highly qualified veterinarians brings years of hands-on experience and deep compassion for animals" | "Whether it’s a late-night injury or sudden illness, our emergency care unit is equipped to respond quickly." | "We combine the latest medical technology with advanced diagnostic & tools to deliver comfortable treatments" | "Our gentle approach, friendly staff, and nurturing environment ensure that both pets & their owners feel safe" */
    p0Text: ReactNode;
    /** Detected variants: "choose-item-count" */
    div0ClassName?: string;
    /** Detected variants: "choose-item-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeSixWhySectionGeneratedProps = {
    divDiv1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: WhySectionChooseSixsItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "Benefits" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Why Pet Owners" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Trust Us" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "At our clinic, we blend years of veterinary expertise with genuine compassion to deliver care that goes beyond treatment" */
    sectionDiv0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "choose-img" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/choose-img-8.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "choose-img" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/choose-img-9.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "choose-img" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/choose-img-10.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    whySectionChooseSixs: WhySectionChooseSixsItem[];
    whySectionChooseSixsItemWrapper?: (item: WhySectionChooseSixsItem, content: ReactNode) => ReactNode;
    whySectionChooseSixsRenderer?: (defaultNode: ReactNode) => ReactNode;
    whySectionChooseSixsH3Visible?: boolean;
    whySectionChooseSixsH3Renderer?: (item: WhySectionChooseSixsItem, defaultNode: ReactNode) => ReactNode;
    whySectionChooseSixsH3Props?: Partial<ComponentProps<"h3">> | ((item: WhySectionChooseSixsItem) => Partial<ComponentProps<"h3">>);
};

const HomeSixWhySectionGenerated: FC<HomeSixWhySectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivText = "Benefits",
    sectionDiv0Div0Div0Div0H20H2Text = "Why Pet Owners",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "Trust Us",
    sectionDiv0Div0Div0Div0P0PText = "At our clinic, we blend years of veterinary expertise with genuine compassion to deliver care that goes beyond treatment",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "choose-img",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/choose-img-8.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt = "choose-img",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/about/choose-img-9.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps,
    sectionImageWithBasePath0ImageAlt = "choose-img",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/choose-img-10.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv1H30H3Props,
    sectionDiv0Div0ClassName,
    whySectionChooseSixs,
    whySectionChooseSixsItemWrapper,
    whySectionChooseSixsRenderer,
    whySectionChooseSixsH3Visible,
    whySectionChooseSixsH3Renderer,
    whySectionChooseSixsH3Props,
}) => {
    return (
        <section className="whychoose-section-six section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-xl-6">
                        <div className="section-header-six">
                            <div className="section-sub-title ms-0">{sectionDiv0Div0Div0Div0Div0DivText}</div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    <span className="line-6">{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                            <p>
                                {" "}
                                {sectionDiv0Div0Div0Div0P0PText}
                                {" "}
                            </p>
                        </div>
                        {renderCollectionNode(
                            whySectionChooseSixs,
                            (item: WhySectionChooseSixsItem) => (
                                <div className={item.className} key={item.key}>
                                    <div className={item.div0ClassName ?? "choose-item-count"}>
                                        <span>{item.span0Text}</span>
                                    </div>
                                    <div className={item.div1ClassName ?? "choose-item-content"}>
                                        {renderItemNode(whySectionChooseSixsH3Visible, whySectionChooseSixsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof whySectionChooseSixsH3Props === "function" ? whySectionChooseSixsH3Props(item) : (whySectionChooseSixsH3Props ?? {}))} {...(typeof divDiv1H30H3Props === "function" ? divDiv1H30H3Props(item) : (divDiv1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p>
                                            {" "}
                                            {item.p0Text}
                                        </p>
                                    </div>
                                </div>
                            ),
                            whySectionChooseSixsItemWrapper,
                            whySectionChooseSixsRenderer
                        )}
                    </div>
                    <div className="col-xl-6">
                        <div className="whychoose-img">
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt} className="img-fluid img-two" {...(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSixWhySectionGenerated;
